import React from 'react';

import useWindowSize from '@components/common/hooks/useWindowSize';
import { S_DEVICE } from '@components/lpc/Constants';

import css from './Loading.module.scss';

const Loading = () => {
    const { width } = useWindowSize();

    return (
        <div className={css.loading}>
            <div className={css.loading__navigation}>
                <div className={css.loading__navigation__element}>
                    <div className={css.loading__navigation__text_1} />
                </div>
                <div className={css.loading__navigation__element}>
                    <div className={css.loading__navigation__text_2} />
                </div>
                <div className={css.loading__navigation__element}>
                    <div className={css.loading__navigation__text_3} />
                </div>
                <div className={css.loading__navigation__element}>
                    <div className={css.loading__navigation__text_4} />
                </div>
            </div>
            {width > S_DEVICE && (
                <div className={css.loading__details}>
                    <div className={css.loading__details__element}>
                        <div className={css.loading__navigation__text_1} />
                        <div className={css.loading__details__sub_text} />
                    </div>
                    <div className={css.loading__details__element}>
                        <div className={css.loading__navigation__text_2} />
                        <div className={css.loading__details__sub_text} />
                    </div>
                    <div className={css.loading__details__element}>
                        <div className={css.loading__navigation__text_3} />
                        <div className={css.loading__details__sub_text} />
                    </div>
                    <div className={css.loading__details__element}>
                        <div className={css.loading__navigation__text_4} />
                        <div className={css.loading__details__sub_text} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Loading;
